module.exports = new __parcel__URL__("bossfight_rounds_button_inactive.15e69c11.png").toString();